import { getAudio } from "@/audio";


export const playScarySound = () => {
  const { ctx, out } = getAudio();
  const t = ctx.currentTime;
  const bus = ctx.createGain();
  bus.gain.setValueAtTime(0.0001, t);
  bus.gain.exponentialRampToValueAtTime(0.5, t + 0.05);
  bus.gain.setValueAtTime(0.5, t + 1.8);
  bus.gain.exponentialRampToValueAtTime(0.0001, t + 3);
  bus.connect(out);
  [55, 58.3, 77.8].forEach((f) => {
    const o = ctx.createOscillator();
    o.type = "sawtooth";
    o.frequency.setValueAtTime(f, t);
    o.frequency.exponentialRampToValueAtTime(f * 0.7, t + 3);
    const g = ctx.createGain();
    g.gain.value = 0.25;
    o.connect(g).connect(bus);
    o.start(t);
    o.stop(t + 3.1);
  });
  const scream = ctx.createOscillator();
  const sg = ctx.createGain();
  const vib = ctx.createOscillator();
  const vg = ctx.createGain();
  scream.type = "square";
  scream.frequency.setValueAtTime(1900, t + 0.1);
  scream.frequency.exponentialRampToValueAtTime(240, t + 2.2);
  vib.frequency.value = 13;
  vg.gain.value = 60;
  vib.connect(vg).connect(scream.frequency);
  sg.gain.setValueAtTime(0.0001, t);
  sg.gain.exponentialRampToValueAtTime(0.09, t + 0.15);
  sg.gain.exponentialRampToValueAtTime(0.0001, t + 2.4);
  scream.connect(sg).connect(bus);
  [scream, vib].forEach((o) => { o.start(t); o.stop(t + 2.5); });
  const buf = ctx.createBuffer(1, ctx.sampleRate * 0.6, ctx.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const n = ctx.createBufferSource();
  n.buffer = buf;
  const nf = ctx.createBiquadFilter();
  nf.type = "lowpass";
  nf.frequency.value = 900;
  n.connect(nf).connect(bus);
  n.start(t);
  setTimeout(() => bus.disconnect(), 3300);
  window.__eatSounds = [...(window.__eatSounds || []), "scary"].slice(-50);
};
